import { render, staticRenderFns } from "./preview-email-template.vue?vue&type=template&id=2997ebf0&scoped=true"
import script from "./preview-email-template.vue?vue&type=script&lang=js"
export * from "./preview-email-template.vue?vue&type=script&lang=js"
import style0 from "./preview-email-template.vue?vue&type=style&index=0&id=2997ebf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997ebf0",
  null
  
)

export default component.exports